import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function MyAttendance() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/attendance/me").then(({ data }) => setItems(data)); }, []);

  return (
    <div className="space-y-6" data-testid="my-attendance-page">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">Devamım</h1>
        <p className="text-muted-foreground text-sm mt-1">Geçmiş giriş-çıkış kayıtlarınız</p>
      </div>

      <div className="glass-card rounded-xl overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Tarih</TableHead>
              <TableHead>Giriş</TableHead>
              <TableHead>Çıkış</TableHead>
              <TableHead>Geç (dk)</TableHead>
              <TableHead>Fazla Mesai (dk)</TableHead>
              <TableHead>Çalışılan (sa)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((r) => (
              <TableRow key={r.id}>
                <TableCell className="font-mono">{r.date}</TableCell>
                <TableCell className="font-mono">{r.check_in ? new Date(r.check_in).toLocaleTimeString("tr-TR") : "—"}</TableCell>
                <TableCell className="font-mono">{r.check_out ? new Date(r.check_out).toLocaleTimeString("tr-TR") : "—"}</TableCell>
                <TableCell><Badge variant={r.late_minutes > 0 ? "destructive" : "secondary"}>{r.late_minutes || 0}</Badge></TableCell>
                <TableCell>{r.overtime_minutes || 0}</TableCell>
                <TableCell className="font-mono">{Math.round((r.worked_minutes || 0) / 60 * 10) / 10}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-10">Kayıt yok.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
